import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const LabelStyles = styled(Typography)`
	color: ${props => (props.color ? props.color : props.theme.label.color)};

	&.MuiTypography-h3 {
		font-weight: 900;
		${props => props.theme.breakpoints.up('xs')} {
			font-size: 12px;
		}
		${props => props.theme.breakpoints.up('md')} {
			font-size: 15px;
		}
	}
`;

export default LabelStyles;
